import {IExtensionPoints, IPlugin, IPluginConfig} from "@athena-portal/core";
import {HelloPage} from "../pages/HelloPage";
import {FalconPropositionEngineImpl, IFalconPropositionEngine, Types} from "@falcon/services";
import {WelcomePage} from "../pages/WelcomePage";
import {RetrievalDetailsPage} from "../pages/quote/RetrievalDetailsPage";
import {RetrieveQuotePage} from "../pages/quote/RetrieveQuotePage";
import {RetrieveQuoteAndProceedPage} from "../pages/quote/RetrieveQuoteAndProceedPage";
import {QuoteLimit} from "../pages/quote/QuoteCloneLimitPage";
import {AggregatorErrorPage} from "../pages/AggregatorErrorPage";
import {EventWarningPage} from "../pages/EventWarningPage";
import {LoginPage} from "../pages/LoginPage";
import {RegisterPage} from "../pages/RegisterPage";
import {ComplaintsPage} from "../pages/complaint/ComplaintsPage";
import {PersonalDataRightsPage} from "../pages/PersonalDataRightsPage";
import {ContactUsPage} from "../pages/ContactUsPage";
import {ViewOrGetQuotesPage} from "../pages/dashboard/common/quotesPage/ViewOrGetQuotesPage";
import {QuickerQuoteErrorPage} from "../pages/QuickerQuoteErrorPage";
import {QuoteYourWayPage} from "../pages/dashboard/common/quotesPage/QuoteYourWayPage";

const plugin: IPlugin<IPluginConfig> = {
    getName(): string {
        return "customerPortal";
    },

    register(extensions: IExtensionPoints, configuration: IPluginConfig): void {
        // Routes
        extensions.routes.add({
            path: "/",
            component: HelloPage,
        });

        extensions.routes.add({
            path: "/products",
            component: ViewOrGetQuotesPage,
        });

        extensions.routes.add({
            path: "/welcome",
            component: WelcomePage,
        });

        extensions.routes.add({
            path: "/retrieveQuote",
            component: RetrievalDetailsPage,
        });

        extensions.routes.add({
            path: "/retrieveQuote/products/:product/process/:process/interaction/:interactionId/language/:languageCode/email/:email/dob/:dateOfBirth",
            component: RetrieveQuotePage,
        });

        extensions.routes.add({
            path: "/retrieveQuote/:token",
            component: RetrieveQuoteAndProceedPage,
        });

        extensions.routes.add({
            path: "/quoteLimit",
            component: QuoteLimit,
        });

        extensions.routes.add({
            path: "/aggregatorError/:aggregator",
            component: AggregatorErrorPage,
        });

        extensions.routes.add({
            path: "/quickerQuoteError",
            component: QuickerQuoteErrorPage,
        });

        extensions.routes.add({
            path: "/eventWarningPage",
            component: EventWarningPage,
        });

        extensions.routes.add({
            path: "/login",
            component: LoginPage,
        });

        extensions.routes.add({
            path: "/register",
            component: RegisterPage,
        });

        extensions.routes.add({
            path: "/complaints",
            component: ComplaintsPage,
        });

        extensions.routes.add({
            path: "/dataRights",
            component: PersonalDataRightsPage,
        });

        extensions.routes.add({
            path: "/contact",
            component: ContactUsPage,
        });

        extensions.routes.add({
            path: "/quoteYourWay",
            component: QuoteYourWayPage,
        });

        // Services
        extensions.services.bind<IFalconPropositionEngine>(Types.FalconPropositionEngine).to(FalconPropositionEngineImpl);
    }
};

export default plugin;
